export const heights = {
    autoSizeOffsetBottom: 200,
    minSectionHeight: 450,
};
